import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
const testimonials = [{
  quote: 'Antes pasaba horas el fin de semana armando informes. Con estas plantillas, en 15 minutos tengo todo listo y súper profesional. Me salvó la vida.',
  name: 'Luciana M.',
  role: 'AT',
  location: 'Buenos Aires, Argentina'
}, {
  quote: 'Siempre sentí que mis registros no estaban a la altura de los psicólogos del equipo. Ahora entrego informes que dan gusto leer. Me dio muchísima seguridad.',
  name: 'Martín R.',
  role: 'AT',
  location: 'Córdoba, Argentina'
}, {
  quote: 'Trabajo con tres obras sociales distintas y cada una pide cosas diferentes. El sistema me organizó la cabeza y el trabajo. Excelente inversión.',
  name: 'Valeria S.',
  role: 'AT',
  location: 'Rosario, Argentina'
}, {
  quote: 'Llegaba a casa agotada y tener que escribir era una tortura. El banco de frases es oro puro. Lo recomiendo a todos los colegas.',
  name: 'Camila F.',
  role: 'AT',
  location: 'La Plata, Argentina'
}, {
  quote: 'Recién empiezo en la profesión y estaba perdidísima con la parte administrativa. Esto es literalmente lo que no te enseñan en el curso de AT.',
  name: 'Fernanda T.',
  role: 'AT',
  location: 'Mendoza, Argentina'
}];
export function TestimonialsSection() {
  return <section className="py-14 px-4 sm:px-6 lg:px-8 max-w-6xl mx-auto" data-id="element-274">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="text-center mb-16" data-id="element-275">
        <h2 className="text-3xl md:text-4xl font-bold text-white font-heading mb-4 tracking-wider" data-id="element-276">
          LO QUE DICEN OTROS AT
        </h2>
        <div className="w-24 h-1 bg-gold-gradient mx-auto rounded-full" data-id="element-277" />
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-278">
        {testimonials.map((test, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: index * 0.1
      }} className={`bg-[#0f1d36] border border-[#1a2b4c] rounded-2xl p-6 md:p-8 relative ${index === 4 ? 'md:col-span-2 lg:col-span-1 lg:col-start-2' : ''}`} data-id="element-279">
            <Quote className="w-10 h-10 text-[#d4af37]/20 absolute top-6 right-6" data-id="element-280" />

            <div className="flex gap-1 mb-6" data-id="element-281">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-[#d4af37] text-[#d4af37]" data-id="element-282" />)}
            </div>

            <p className="text-[#e2e8f0] italic mb-8 relative z-10" data-id="element-283">
              "{test.quote}"
            </p>

            <div className="mt-auto pt-4 border-t border-[#1a2b4c]" data-id="element-284">
              <p className="text-white font-bold" data-id="element-285">{test.name}</p>
              <p className="text-[#a0aec0] text-sm" data-id="element-286">
                {test.role} · {test.location}
              </p>
            </div>
          </motion.div>)}
      </div>
    </section>;
}